/**
 * Entities store a bare object key (`aB3dE6gH9jK2`), never a URL — this turns one into a URL at
 * render time.
 *
 * `size` is not a transform. R2 has none: an upload writes the original and a 256px thumb, and
 * any sized request resolves to that thumb. The parameter is kept so the call sites that had it
 * do not change, and its exact values are deliberately ignored.
 *
 * The base URL is read here, not at module scope, so stubbing it in a test does not depend on
 * import timing (RULING R2).
 */
export const getImageUrl = (fileId: string | null | undefined, size?: { width: number; height: number }) => {
  const cdnBaseUrl = (import.meta.env.VITE_CDN_BASE_URL ?? '').replace(/\/$/, '');
  if (!fileId || !cdnBaseUrl) return null;
  return `${cdnBaseUrl}/${size ? `${fileId}/thumb` : fileId}`;
};

/**
 * A menu icon is either one of the local `/menu/*.png` presets or an uploaded object key.
 * A leading slash tells them apart: `generateEntityToken` mints 12 alphanumerics, so no key
 * can start with one. Presets are served by the portal itself and need no CDN resolution.
 */
export const resolveIconUrl = (value: string | null | undefined) => {
  if (!value) return null;
  return value.startsWith('/') ? value : getImageUrl(value);
};
